import { useContext, useState } from 'react';

import {
  Space,
  Typography,
  Badge,
  Popover,
  Flex,
  Tooltip,
  Dropdown,
} from 'antd';
import moment from 'moment/moment';
import { formatCompactDate } from '../../../../helper/webChatHelpers';
import { cn } from '../../../../../../helper/cn';
import Arrow from '../../../../../../assets/customSVG/Arrow';
import { useDispatch, useSelector } from 'react-redux';
import MessageStatus from '../Message/MessageStatus';
import { participant_types } from '../../../../constants/WebchatConstants';
import { DeleteOutlined, StarOutlined } from '@ant-design/icons';
import { favoriteConversation } from '../../../../../../reduxToolkit/inboxSlice';
import NotificationContext from '../../../../../../providers/NotificationProvider';
import { showSuccessToast } from '../../../../../../components/commonComponents/gxAntdToast/toastUtils';
import { formatRelativeTime } from '../../../../helper/index';
const { Text } = Typography;

const Conversation = ({
  conversation,
  isSelected,
  getConversationMessages,
}) => {
  // hooks
  const dispatch = useDispatch();
  const toast = useContext(NotificationContext);

  // states
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // selectors
  const { currentBrand } = useSelector((state) => state?.app);
  const { teamMembers, selectedWebChatTeam } = useSelector(
    (state) => state?.inbox,
  );
  const { last_message = {} } = conversation;

  const participantType = participant_types[last_message?.participant_type];
  const teamMember = teamMembers.find((member) => {
    return member.team_member_id == last_message?.team_member_id;
  });

  const items = [
    {
      key: '1',
      label: (
        <Text
          className={cn(
            conversation?.favorite_status == 10
              ? 'text-red-600'
              : 'text-yellow-600',
          )}
        >
          {conversation?.favorite_status == 10 ? 'Unfavorite' : 'Favorite'}
        </Text>
      ),
      icon: (
        <StarOutlined
          style={{
            color: conversation?.favorite_status == 10 ? '#dc2626' : '#ca8a04',
          }}
        />
      ),
      onClick: async (e) => {
        const domEvent = e.domEvent;
        if (domEvent) {
          domEvent.stopPropagation();
        }
        const res = await dispatch(
          favoriteConversation({
            brand_id: currentBrand?.brand_id,
            team_id: selectedWebChatTeam?.team_id,
            conversation_id: conversation?.id,
            team_member_id: selectedWebChatTeam?.team_member_id,
            method: conversation?.favorite_status == 10 ? 'delete' : 'put',
          }),
        );
        if (res?.payload?.res?.status == 10) {
          showSuccessToast(toast, 'Conversation added to favorites', 2);
        } else {
          showSuccessToast(toast, 'Conversation removed from favorites', 2);
        }
      },
    },
    {
      key: '2',
      label: 'Delete Chat',
      icon: <DeleteOutlined />,
      disabled: true,
    },
  ];
  return (
    <Dropdown
      onClick={(e) => {
        e.stopPropagation();
      }}
      onOpenChange={(open) => {
        if (!open) setIsDropdownOpen(open);
      }}
      open={isDropdownOpen}
      destroyPopupOnHide
      menu={{ items }}
      trigger={['click']}
      placement="bottomRight"
      rootClassName="min-w-[82px_!important]"
    >
      <Space
        key={conversation.id}
        direction="vertical"
        className={cn(
          'w-full rounded-md p-2 border-b-[1px] border-gray-200 cursor-pointer justify-between my-1 transition-all ease-in-out group py-3 hover:bg-slate-100 hover:border-slate-100',
          isSelected &&
            'bg-[#e1f6e9] border-s-2 border-s-green-600 border-b-0 hover:bg-[#e1f6e9] hover:border-s-2 hover:border-s-green-600',
        )}
        onClick={() => {
          getConversationMessages(conversation);
        }}
      >
        <Flex
          className="w-full transition-all ease-in-out"
          align="center"
          justify="space-between"
        >
          <Text className="font-medium">{conversation.agent_session_id}</Text>
          {/* id: {conversation.id} */}
          <Popover
            mouseEnterDelay={1}
            mouseLeaveDelay={0.1}
            content={
              <Text className="text-gray-600">
                {/* To local time stamp */}
                {moment(conversation.updated_at)
                  .local()
                  .format('MMMM Do YYYY, h:mm:ss a')}
                {/* {formatRelativeTime(conversation.updated_at)} */}
              </Text>
            }
          >
            <Text className="text-xs text-gray-600">
              {/* convert to local time */}
              {formatRelativeTime(moment(conversation.updated_at).local())}
            </Text>
          </Popover>
        </Flex>
        <Flex align="end" className="transition-all ease-in-out">
          <div
            style={{ flex: 1, minWidth: 0 }}
            className="transition-all ease-in-out"
          >
            <Flex gap={3} align="center" style={{ width: '100%' }}>
              <MessageStatus
                status={last_message?.status}
                timestamp={last_message?.message_created_at}
                participantType={participantType}
              />
              <Text className="text-xs text-ellipsis overflow-hidden whitespace-nowrap">
                {teamMember
                  ? `${teamMember?.screen_name}: `
                  : last_message?.contact_id
                  ? `Widget user: `
                  : ''}
                {/* {last_message.contact_id } */}
                <Tooltip
                  placement="bottomLeft"
                  color="oklch(96.7% 0.001 286.375)"
                  mouseEnterDelay={1}
                  title={
                    <Text className="text-xs text-[oklch(70.5% 0.015 286.067)]">
                      {last_message?.message}
                    </Text>
                  }
                >
                  <Text className="text-xs text-[#616874]">
                    {last_message?.message || 'No messages'}
                  </Text>
                </Tooltip>
              </Text>
            </Flex>
          </div>

          {/* Right container - Fixed width */}
          <div
            className={`flex-[0_0_0] transition-all bg-gray-50 ease-in-out group-hover:flex-[0_0_max-content] flex items-center gap-0 group-hover:gap-1 ${
              isSelected ? 'bg-[#e1f6e9]' : 'group-hover:bg-gray-100'
            }`}
          >
            <Badge
              color={
                conversation?.unread_messages_count > 0 ? 'green' : undefined
              }
              count={conversation?.unread_messages_count || 0}
            />

            {/* <Dropdown
            onClick={(e) => {
              e.stopPropagation();
            }}
            destroyPopupOnHide
            menu={{ items }}
            trigger={['click']}
            placement="bottom"
          > */}
            <div
              onClick={(e) => {
                e.stopPropagation();
                setIsDropdownOpen(!isDropdownOpen);
              }}
            >
              <Arrow className="transition-all ease-in-out rotate-[270deg] scale-0 w-0 group-hover:scale-100 group-hover:w-5" />
            </div>
          </div>
        </Flex>
      </Space>
    </Dropdown>
  );
};

export default Conversation;
